import { render, staticRenderFns } from "./packageManagement.vue?vue&type=template&id=6d1471fb"
import script from "./packageManagement.vue?vue&type=script&lang=js"
export * from "./packageManagement.vue?vue&type=script&lang=js"
import style0 from "./packageManagement.vue?vue&type=style&index=0&id=6d1471fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports